<div
    bsModal
    #createOrEditModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #StockAdjustmentForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span *ngIf="stockAdjustment.id">{{ l('EditStockAdjustmentType') }}</span>

                        <span *ngIf="!stockAdjustment.id">{{ l('CreateNewStockAdjustmentType') }}</span>
                    </h4>

                    <button
                        type="button"
                        class="btn-close"
                        (click)="close()"
                        aria-label="Close"
                        [disabled]="saving"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="my-3">
                        <label class="form-label" for="StockAdjustment_Name">{{ l('Name') }} *</label>
                        <input
                            type="text"
                            #StockAdjustment_Name="ngModel"
                            id="StockAdjustment_Name"
                            class="form-control"
                            [(ngModel)]="stockAdjustment.type"
                            name="Name"
                            minlength="0"
                            maxlength="500"
                            required
                        />
                        <validation-messages [formCtrl]="StockAdjustment_Name"></validation-messages>
                    </div>
                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-danger" (click)="close()">
                        {{ l('Cancel') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!StockAdjustmentForm.form.valid"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
